<template>
    <div class="page-container">
        <site-header />
        <div class="profile">
            <h1>个人资料</h1>
            <div class="profile-form">
                <el-descriptions :column="1" border>
                    <el-descriptions-item label="用户名">{{ userForm.userName }}</el-descriptions-item>
                    <el-descriptions-item label="姓名">{{ userForm.name }}</el-descriptions-item>
                    <el-descriptions-item label="性别">{{ sexText }}</el-descriptions-item>
                    <el-descriptions-item label="身份证号">{{ userForm.idCard }}</el-descriptions-item>
                    <el-descriptions-item label="学历">{{ userForm.education }}</el-descriptions-item>
                    <el-descriptions-item label="省份">{{ userForm.province }}</el-descriptions-item>
                    <el-descriptions-item label="学校">{{ userForm.school }}</el-descriptions-item>
                    <el-descriptions-item label="手机号">{{ userForm.phone }}</el-descriptions-item>
                    <el-descriptions-item label="邮箱">{{ userForm.email }}</el-descriptions-item>
                </el-descriptions>
            </div>
        </div>
        <site-footer />
    </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { getUserInfo } from '@/api/login'

export default {
    name: 'UserProfile',
    components: {
        SiteHeader,
        SiteFooter
    },
    data() {
        return {
            userForm: {
                userName: '',
                name: '',
                sex: '',
                idCard: '',
                education: '',
                province: '',
                school: '',
                phone: '',
                email: ''
            }
        }
    },
    computed: {
        sexText() {
            return this.userForm.sex === '0' ? '男' : this.userForm.sex === '1' ? '女' : '未知'
        }
    },
    async created() {
        try {
            // 获取用户信息
            const response = await getUserInfo()
            if (response.data) {
                this.userForm = { ...response.data }
            }
        } catch (error) {
            this.$message.error('获取用户信息失败')
        }
        // 设置为个人中心模式
        this.$store.dispatch('setPersonalCenterMode', true)
    },
    beforeDestroy() {
        // 组件销毁前，如果不是跳转到其他个人中心页面，则退出个人中心模式
        const personalCenterRoutes = ['/archive-course', '/purchased-course', '/grade-query', '/e-certificate', '/profile']
        if (!personalCenterRoutes.includes(this.$route.path)) {
            this.$store.dispatch('setPersonalCenterMode', false)
        }
    }
}
</script>

<style scoped>
.page-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.profile {
    flex: 1;
    padding: 20px;
    background: #f5f7fa;
}

.profile h1 {
    text-align: center;
    color: #333;
    margin-bottom: 30px;
}

.profile-form {
    max-width: 800px;
    margin: 20px auto;
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

:deep(.el-descriptions__label) {
    width: 100px;
    font-weight: 500;
}

:deep(.el-descriptions__content) {
    color: #333;
}

@media screen and (max-width: 768px) {
    .profile {
        padding: 12px;
    }

    .profile h1 {
        font-size: 20px;
        margin-bottom: 16px;
    }

    .profile-form {
        padding: 16px;
        margin: 12px auto;
    }

    :deep(.el-descriptions__label) {
        width: 80px;
    }

    :deep(.el-descriptions-item__container) {
        flex-wrap: wrap;
    }
}
</style>